import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

class SubscriptionSelector extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector('[data-selector]');
    this.registerEvents();
  }

  /**
   *
   * @returns {string} returns selector name.
   */
  getSelectorName() {
    return this.dataset.name;
  }

  /**
   *
   * @param {'true'|'false'} state
   */
  setState(state) {
    this.dataset.selected = state;
  }

  /**
   * Register events on the constructor.
   */
  registerEvents() {
    this.selector.addEventListener('click', () => {
      dispatchEvent(EVENT.SUBSCRIPTION.SELECTOR.SELECTED, document, {
        detail: {
          name: this.getSelectorName(),
        },
      });
    });

    document.addEventListener(EVENT.SUBSCRIPTION.SELECTOR.SELECTED, event => {
      if (event.detail.name === this.getSelectorName()) {
        this.setState(STATE.SUBSCRIPTION.SELECTOR.SELECTED.TRUE);
        this.selector.setAttribute('checked', true);
      } else {
        this.setState(STATE.SUBSCRIPTION.SELECTOR.SELECTED.FALSE);
        this.selector.removeAttribute('checked');
      }
    });
  }
}

customElements.define('subscription-selector', SubscriptionSelector);
